<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import i18next from 'i18next';

export default {
  name: 'App',
  created() {
    i18next.changeLanguage('th');
  },
};
</script>

<style lang="scss">
@import 'assets/scss/app';
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
